<div
  class="avatar-wrapper"
  [class.avatar-wrapper--dark]="variant === 'dark'"
  [class.avatar-wrapper--light]="variant === 'light'"
  [style.width]="size + 'px'"
  [style.height]="size + 'px'">
  <div class="logo" [sxBackground]="'white'" [style.background-image]="'url(' + getUrl() + ')'">
    @if (title && !imageUrl) {
      <div class="initial-wrapper" [sxBackground]="initialsSxBackground">
        <p [style.font-size]="getInitialsFontSize()">{{ getInitials(title) }}</p>
      </div>
    }

    @if (lock) {
      <div class="lock">
        <ion-icon size="small" name="lock-closed-outline"></ion-icon>
      </div>
    }
  </div>
  @if (isEditMode) {
    <div
      class="bubble"
      [class.filled]="bubbleFilled"
      (click)="onCameraClicked()"
      [style.width]="bubbleSize + 'px'"
      [style.height]="bubbleSize + 'px'"
      [style.top]="getBubbleTop() + 'px'"
      [style.left]="getBubbleLeft() + 'px'">
      @if (!isOnAction) {
        <ion-icon name="camera-outline"></ion-icon>
      } @else {
        <ion-spinner></ion-spinner>
      }
    </div>
  }
</div>

<app-upload-image-button
  #uploadImageButtonComponent
  hidden
  (onImageUpload)="onImageLoad($event)"></app-upload-image-button>
